module.exports = __webpack_public_path__ + "static/media/Karge Logo-01.3967e392.png";